import { AnyAction } from 'redux';

const GET_DOCUMENT_DETAIL = 'GET_DOCUMENT_DETAIL';

const intialState = { data: [] };

export async function setDocumentDetail(dispatch: any, documentDetail: any) {
  dispatch({
    type: GET_DOCUMENT_DETAIL,
    data: documentDetail
  });
}

export const documentDetailReducer = (state = intialState, action: AnyAction) => {
  switch (action.type) {
    case GET_DOCUMENT_DETAIL: {
      return {
        ...state,
        data: action.data
      };
    }
    default:
      return state;
  }
};
